import { formatDateForHash, getHashObj } from "@/utils/utils";
import getFirstAvailableResponse from "@/vue/planning/logic/getFirstAvailableResponse"
import isHaveAvailability from "@/vue/planning/logic/isHaveAvailability"
import { AvailabilitiesResponse } from "@/types/responses";
import packConfig from "@/config/packConfig"

const getHashPackCode = (): string | undefined => {
    const hash = window.location.hash.replace("#", "")
    const hashObj = getHashObj(hash) as {[key: string]: string}
    const hashPackCode: string | undefined = hashObj.packCode
    return hashPackCode
}

const ensureValidPackCodeIsSelected = (avail_resp: AvailabilitiesResponse, dispatch: any) => {
    const allAvailablePackCodesSet:Set<string> = new Set()

    avail_resp.availablePackages!.forEach(availablePackage => {
        allAvailablePackCodesSet.add(availablePackage.codePackage!)
    });

    const hashPackCode: string | undefined = getHashPackCode()

    if(!hashPackCode || !allAvailablePackCodesSet.has(hashPackCode)) {
        let wasPackageSet = false
        for(const priorityPackCode of packConfig) {
            if(allAvailablePackCodesSet.has(priorityPackCode)) {
                dispatch("setPackage", priorityPackCode)
                wasPackageSet = true
                break
            }
        }
        if(!wasPackageSet) {
            dispatch("setPackage", avail_resp?.codePack) 
        }
    }
}


const makeInitialAvailRequest = async (storeObj: any) => {
    const { state, commit, dispatch } = storeObj

    const hashPackCode: string | undefined = getHashPackCode()

    let avail_resp = await getFirstAvailableResponse(storeObj, hashPackCode)

    // if still no availability - switch season
    if (!isHaveAvailability(avail_resp)) {
        commit("setSeason", state.season === "E" ? "H" : "E")
        window.seasonManager.switchSeasonWithoutReloading()

        avail_resp = await getFirstAvailableResponse(storeObj, hashPackCode)
    }
    if (!isHaveAvailability(avail_resp)) { // exit if product not available
        commit("setProductUnavailable", true)
        dispatch("setLoading", false)
        return
    }

    // set packCode if it was empty, or it's not available
    ensureValidPackCodeIsSelected(avail_resp, dispatch)

    // set dates from response if url doesnt have them
    if (Object.keys(state.dates).length === 0) {
        dispatch("setDates", {
            "BeginDate": formatDateForHash(avail_resp?.endDates?.startDate),
            "EndDate": formatDateForHash(avail_resp?.endDates?.endDate),
        })
    }

    return avail_resp
}

export default makeInitialAvailRequest